export default "__VITE_ASSET__DI9x17WX__"